import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.submitting = false
  }

  submit(event) {
    if (this.submitting) {
      event.preventDefault()
      return false
    }

    this.submitting = true

    this.buttonTargets.forEach((el) => {
      el.disabled = true
      el.classList.add("opacity-75", "cursor-not-allowed")

      const loadingText = el.dataset.loadingText || "Processing..."

      if (el.tagName === "INPUT") {
        el.dataset.originalValue = el.value
        el.value = loadingText
      } else {
        el.dataset.originalText = el.textContent.trim()
        el.textContent = loadingText
      }
    })
  }
}
